import './src/styles/global.css';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}
// gatsby-ssr.tsx
import React from 'react';
import MDXLayout from './src/components/MDXLayout';
import { PageContextProvider } from './src/components/PageContext';

const GTAG_ID = process.env.GATSBY_GTAG;

export const wrapPageElement = ({ element, props }) => {
  const isMDXPage = !!props?.pageContext?.frontmatter; // hacky way to check if this is an MDX page
  if (isMDXPage) {
    return (
      <PageContextProvider value={props.pageContext}>
        <MDXLayout pageContext={props.pageContext}>{element}</MDXLayout>
      </PageContextProvider>
    );
  }
  return (
    <PageContextProvider value={props.pageContext}>
      {element}
    </PageContextProvider>
  );
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag !== `function`) {
    return null;
  }

  const delayOnRouteUpdate = 0;

  // wrap inside a timeout to make sure react-helmet is done with its changes (https://github.com/gatsbyjs/gatsby/issues/11592)
  const sendPageView = () => {
    const pagePath = location
      ? location.pathname + location.search + location.hash
      : undefined;
    window.gtag(`event`, `page_view`, { page_path: pagePath });
  };
  if (`requestAnimationFrame` in window) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setTimeout(sendPageView, delayOnRouteUpdate));
    });
  } else {
    // Delay by 32ms to simulate 2 requestOnAnimationFrame calls
    setTimeout(sendPageView, 32 + delayOnRouteUpdate);
  }
};
